import comp from "./DynamicTable";
export default comp;
